import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/system/Container';
import MainAppBar from 'front/MainAppBar';
import MinHeightContainer from 'front/MinHeightContainer';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../common/store/store';
import { Footer } from './Footer';

export const MasterViewPage = (props: { children?: React.ReactNode; }) => {

    const visible = useSelector((state: AppState) => state.contact.visible);
    const active = useSelector((state: AppState) => state.contact.active);

    const goToSoumission = (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        (document as any).querySelector('#soumission').scrollIntoView({
            behavior: 'smooth'
        });
    };

    const getContent = () => {
        return <div>
            <MinHeightContainer>
                <div className="orange"><Container><MainAppBar /></Container></div>
                {props.children}
            </MinHeightContainer>
            <Container><Footer></Footer></Container>
            {active && !visible ? <Box sx={{ pointerEvents: 'none', position: 'fixed', top: 15, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button component='a' href="#soumission" sx={{ zIndex: 1, pointerEvents: 'auto' }} onClick={goToSoumission} variant='contained' size='large'>Envoyer une<br />Soumission</Button>
            </Box> : null}
        </div>;
    };
    return <>{getContent()}</>;


};
